import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Stack, Typography } from '@mui/material';

import { ROUTES } from '@constants/routes';

import type { NotificationSubscriptionResultPayload } from '@system/app';
import { NotificationEvents, useApp } from '@system/app';

export function useRedirectToLogout() {
  const navigate = useNavigate();
  const { notification, confirmDialog, flags } = useApp();

  const maintenance_mode = flags?.find(
    item => item.name === 'maintenance_mode',
  );

  const isMaintenanceMode = maintenance_mode?.value === 'on';

  const redirectToLogout = useCallback(
    (payload: NotificationSubscriptionResultPayload) => {
      const message = (
        <Stack p={1}>
          <Typography variant="body1">{payload.data.message}</Typography>

          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold' }}
          >
            Сеанс завершён, авторизуйтесь повторно.
          </Typography>
        </Stack>
      );
      confirmDialog.set({
        title: 'Внимание!',
        message,
        onClose: () => {
          navigate(ROUTES.LOG_OUT);
        },
        buttonClose: {
          text: 'Закрыть',
        },
      });
    },
    [confirmDialog, navigate],
  );

  useEffect(() => {
    if (!isMaintenanceMode) {
      const handlerLink = notification.subscribe(
        NotificationEvents.actionRedirectLogout,
        redirectToLogout,
      );
      return () => {
        notification.unsubscribe(
          NotificationEvents.actionRedirectLogout,
          handlerLink,
        );
      };
    }
  }, [isMaintenanceMode, notification, redirectToLogout]);

  return null;
}
